<template>
    <div>
        <v-head :title="title"></v-head>
        <div class="swiperBox">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
                <van-swipe-item><img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1584945833233&di=34fa6bf19c9274f440a740ac2cf1f0c9&imgtype=0&src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2017-11-07%2F5a0147715cfcd.jpg"/></van-swipe-item>
                <van-swipe-item><img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1584945774325&di=346814ce1212f75811c3548aa50f3ff5&imgtype=0&src=http%3A%2F%2Fpic1.win4000.com%2Fwallpaper%2F2017-10-26%2F59f17cbb96036.jpg"/></van-swipe-item>
                <van-swipe-item><img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1584945774322&di=63c9aa373740287b1ecc18f4002c6fdd&imgtype=0&src=http%3A%2F%2Fa0.att.hudong.com%2F51%2F29%2F31300542645450140723293605403.jpg"/></van-swipe-item>
                <van-swipe-item><img src="https://ss0.bdstatic.com/70cFvHSh_Q1YnxGkpoWK1HF6hhy/it/u=3241004174,2194599020&fm=26&gp=0.jpg" /></van-swipe-item>
            </van-swipe>
        </div>
        <div v-for="(resource,index) in resources.content" :key="index" class="listBox">
            <ul>
                <li>
                    <div class="listTop">
                        <div class="imgTxBox">
                            <van-image round  width="55" height="55" :src="getPortrait(resource.memberID)" />
                        </div>
                        <div class="nameTxBox">
                            <div>{{fitMember(resource.memberID)}}</div>
                            <div>{{resource.createTime}}</div>
                        </div>
                    </div>
                    <p style="clear: both;margin-top: 7px;line-height: 21px">{{resource.title}}</p>
                    <p style="margin-top: 10px;line-height: 21px; margin-bottom:20px">{{resource.resourceDesc}}</p>
                    <div v-for="file in fileList.get(resource.id)" :key="file.id">
                        <span v-if="file.suffix=='.png'||file.suffix=='.jpg'" >
                            <van-image
                                    width="100"
                                    height="100"
                                    @click="preview(file.id)"
                                    :src="getPhoto(file.id)"
                            />
                        </span>
                        <a style="color: #f1861e;line-height: 21px" @click="showPdf(file.id)" v-if="file.suffix=='.pdf'" >{{file.fileName}}</a>
                    </div>
                    <div style="margin-top: 20px">免费资源</div>
                    <van-divider />
                    <p style="height: 20px;"></p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {
    Icon,
    Swipe,
    SwipeItem,
    Tabbar,
    TabbarItem,
    Tab,
    Tabs,
    Image ,
    Divider,
    Button,
    Popup,
    ImagePreview ,
} from 'vant';
import {
    getResourceList,
    getMemberInfo,
    getBase64htp,
    getBase64,
    getResourceFile
} from "@/api/dictionary";
import vHead from "../../components/Subhead.vue";
import tabbar from "../../components/tabbar"
import {} from "@/utils/sessionStorage.js"
import {mapState} from "vuex";
export default {
  data() {
    return {
        active1:0,
        page:1,
        title:'资源共享',
        resources:[],
        members:[],
        photoUrl:"",
        resourceType:"",
        fileList:new Map(),
    };
  },
  filters: {
    
  },
  components: {
      vHead,
      tabbar,
      [Icon.name]:Icon,
      [Swipe.name]:Swipe,
      [Popup.name]:Popup,
      [SwipeItem.name]:SwipeItem,
      [Tab.name]:Tab,
      [Image .name]:Image ,
      [Popup .name]:Popup ,
      [Tabs.name]:Tabs,
      [Tabbar.name]:Tabbar,
      [TabbarItem.name]:TabbarItem,
      [Divider.name]:Divider,
      [Button.name]:Button,
      [ImagePreview.name]:ImagePreview ,
  },
  methods: {
      preview(fileId){
          getBase64({id:fileId}).then(res=>{
              ImagePreview([
                  res.result
              ]);
          });
      },
	 getResource(val){
	     if(!val)val=0;
         getResourceList({resourceType:val},this.page-1).then(res=>{
            this.resources = res.result;
            let memberId = [];
            res.result.content.filter(item=>{memberId.push(item.memberID)});
            getMemberInfo({"memberId":memberId.toString()}).then(members=>{
                this.members = members.result;
            })
            this.getFileList();
         });
     },
     fitMember(id){
	     let members = this.members.filter(item =>item.id ==id);
	     if(members.length>0){
             return members[0].name;
         }else {
	         return "未知";
         }
     },
      getPortrait(id){
	     let members = this.members.filter(item =>item.id ==id);
	     if(members.length>0&&members[0].portraitId){
             getBase64({id:members[0].portraitId}).then(res=>{
                 this.photoUrl = res.result;
             });
             return this.photoUrl;
         }else {
	         return "";
         }
     },
      getPhoto(id){
         getBase64({id:id}).then(res=>{
             this.photoUrl = res.result;
         });
         return this.photoUrl;
     },
      getFileList(){
          for (let i = 0; i < this.resources.content.length; i++) {
              let id = this.resources.content[i].id;
              getResourceFile({resourceId:id}).then(res=>{
                  this.fileList.set(id,res.result);
              });
          }
      },
      showPdf(url){
          this.$router.push({path:"/preview",query:{"url":url}});
      }
      /*getResourceFileList(id){
          getResourceFile({resourceId:id}).then(res=>{
              if(res.result.length>0){
                  this.resourceType = res.result[0].suffix;
              }
              this.resourceFileList = res.result;
          });
          return this.resourceFileList;
      }*/
  },
  watch:{
      active1(val){
          if(val==1){
              this.getResource(2);
          }
          if(val==0){
              this.getResource(0);
          }
      }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
	  this.getResource();
	  // this.preview();
  }

}
</script>
<style scoped>
    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }
    .van-button {margin-left: 32px;}
    .swiperBox .van-swipe{height:180px}
    .swiperBox img{ height: 180px;}
    .listBox{ padding: 0 20px; margin-top: 20px;}
    .listTop{ overflow: hidden;}
    .listTop>div{ float: left;}
    .listTop .nameTxBox{ line-height: 24px; margin-top: 5px; margin-left: 20px;}
    .my-swipe img{ width: 100%;}
</style>